/**
 * Token estimation utility - approximates token count for text
 * This provides a rough estimation for token limits in chat inputs
 */
export const estimateTokenCount = (text: string): number => {
  if (!text.trim()) return 0;
  
  // Clean the text
  const cleanText = text.trim();
  
  // Method 1: Word-based estimation (more accurate for most languages)
  const words = cleanText.split(/\s+/).filter(word => word.length > 0);
  const wordBasedEstimate = words.length;
  
  // Method 2: Character-based estimation (4 chars ≈ 1 token for English)
  const charBasedEstimate = Math.ceil(cleanText.length / 4);
  
  // Use the higher estimate for safety, but cap at reasonable bounds
  const estimate = Math.max(wordBasedEstimate, charBasedEstimate);
  
  // Add small buffer for punctuation, formatting, etc.
  return Math.ceil(estimate * 1.1);
}; 